// The saved Works Cited list, revault:citations: [{ id, style, text, m }].
// Every write reads what is stored right now, changes it and writes it back, so two open Citation
// tabs never undo each other's additions or removals.
// m is when a citation was added or changed, and revault:cite-del { [id]: ts } when one was
// removed, so study sync (shared/merge-save.js) can carry a removal to the student's other devices.
import { readJSON, save, subscribe } from "../shared/store.js";

export const KEY = "revault:citations";
export const DEL_KEY = "revault:cite-del";
const TOMB_MS = 60 * 864e5;

export function load() { const v = readJSON(KEY, []); return Array.isArray(v) ? v.filter((c) => c && typeof c === "object" && typeof c.text === "string") : []; }

function loadDel() { const v = readJSON(DEL_KEY, null); return v && typeof v === "object" && !Array.isArray(v) ? v : {}; }

// fn(list) returns the new list (or changes it in place and returns nothing). False when the
// browser refused the write (storage full); other tabs are only told about a saved change.
export function mutateCitations(fn) {
	const list = load();
	const before = new Map(list.map((c) => [String(c.id), c.text]));
	const next = fn(list);
	const out = Array.isArray(next) ? next : list;
	const now = Date.now();
	const seen = new Set();
	for (const c of out) {
		if (!c || typeof c !== "object") continue;
		const k = String(c.id);
		seen.add(k);
		if (!before.has(k) ? !Number.isFinite(c.m) : before.get(k) !== c.text) c.m = now;
	}
	const gone = [...before.keys()].filter((k) => !seen.has(k));
	if (!save(KEY, out)) return false;
	// The list is what matters; a removal that can't be remembered only means another device
	// might bring that citation back.
	const del = loadDel();
	let changed = gone.length > 0;
	for (const k of gone) del[k] = now;
	for (const k of Object.keys(del)) if (!Number.isFinite(del[k]) || del[k] < now - TOMB_MS) { delete del[k]; changed = true; }
	if (changed) save(DEL_KEY, del);
	return true;
}

// fn after the stored list really changed (a change notice alone could come from any page here).
export function onChange(fn) {
	const raw = () => { try { return localStorage.getItem(KEY); } catch { return null; } };
	let last = raw();
	return subscribe(KEY, () => { const v = raw(); if (v === last) return; last = v; fn(); });
}
